/**
 * Composer of functions. Will accept 0 or more functions.
 */
export default (function () {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (arg) {
    return fns.reduceRight(function (acc, fn) {
      return fn(acc);
    }, arg);
  };
});